import React from "react";

// STYLES
import * as Style from "./EventsStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { Navigation, Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";

// MISC
import { availableEventCardDetails, unavailableEventCardDetails } from "mocks/EventsMock";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX

// COMPONENTS
import EventCard from "components/EventCard/EventCard";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const Events = () => {

  // PROPS

  // CONSTANTS USING LIBRARIES
  const navigate = useNavigate();
  
  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.EventsContainer>
      <Style.ButtonContainer>
        <ButtonAtom
          onClick={() => navigate("/event-edit/new-event")}
          text="Adauga eveniment"
          type={ButtonTypes.MAIN_BUTTON}
        />
      </Style.ButtonContainer>

      <Style.Events>
        <Style.Subtitle>Evenimente in derulare</Style.Subtitle>
        <Style.SwiperContainer
          modules={[Pagination]}
          spaceBetween={40}
          slidesPerView={4}
          pagination={{ clickable: true }}
        >
          {availableEventCardDetails.map((eventDetails, index) => {
            return (
              <SwiperSlide key={index}>
                <EventCard
                  key={index}
                  slashBar
                  hasDescription
                  eventDetails={eventDetails}
                />
              </SwiperSlide>
            );
          })}
        </Style.SwiperContainer>
      </Style.Events>

      <Style.Events>
        <Style.SubtitlesContainer>
          <Style.Subtitle>Evenimente anterioare</Style.Subtitle>

          <Style.Link onClick={() => navigate("/events-history")}>
            Istoric Evenimente
          </Style.Link>
        </Style.SubtitlesContainer>
        <Style.SwiperContainer
          modules={[Pagination, Navigation]}
          spaceBetween={40}
          slidesPerView={4}
          pagination={{ clickable: true }}
        >
          {unavailableEventCardDetails.map((eventDetails, index) => {
            return (
              <SwiperSlide key={index}>
                <EventCard
                  key={index}
                  slashBar
                  hasDescription
                  eventDetails={eventDetails}
                />
              </SwiperSlide>
            );
          })}
        </Style.SwiperContainer>
      </Style.Events>
    </Style.EventsContainer>
  );
};

export default Events;
